/* eslint sort-keys: "error" */
/* eslint-env es6 */

import ArgosFeatures from './argos'

const WhiteGoodsOnArgosFeatures = {
  ASK_QUESTION: true,
  ASK_TREVOR_ENABLED: true,
  ATT_MODAL_HIDE_CATEGORIES: false,
  ATT_MODAL_HIDE_EXTRAS: false,
  BASE_URL: 'www.argos.co.uk',
  BREADCRUMB: true,
  CATEGORY_EXPERIENCES_TEMPLATE_ENABLED: false,
  CNET: true,
  COMPARISON_ATTRIBUTES: false,
  COMPLETE_THE_LOOK: false,
  CUSTOMER_GENERATED_CONTENT: false,
  DESCRIPTION_CLASS: 'xs-12--none md-7--none xl-8--none',
  EMAIL_ME_BACK: ArgosFeatures?.EMAIL_ME_BACK,
  ENERGY_SAVING: ArgosFeatures?.ENERGY_SAVING,
  ESSENTIAL_EXTRAS: true,
  FABLE_ATT: true,
  FEATURED_PRODUCTS: true,
  FREQUENTY_BROUHT_TOGETHER: true,
  FULFILMENT_PASS: {
    SHOW_PRODUCT_ELIGIBILITY: true,
    SHOW_PURCHASE_PASS: false
  },
  GO_IN_STORE: false,
  KLARNA_CREDITPLAN: true,
  KLARNA_MESSAGING: {
    dcid:
      'klarna_live_client_MHMtVGopOFZRQShjZFNHYmREOUdWYVFyYURjTk8zWXAsMGM2NjYxYWQtZmU4MS00YWIwLTkxNTYtNzM0NjRjYzA2MGZhLDEsNFpoRFliRUVuTFBnc2NhaFgyUFZTQ1BPL0xBSjJUWkNEODFtUnNJQkxtTT0',
    enabled: true
  },
  MEDIA_CLASS: 'xs-12--none md-7 xl-8',
  MEDIA_PORTRAIT: false,
  MONTHLY_PAYMENT_PLAN: true,
  NECTAR: true,
  PAYPAL_IFC_MESSAGING: true,
  PAYPAL_MESSAGING: true,
  PDP_V2_ENABLED: true,
  PRICING_CLASS: 'xs-12--none md-5--none xl-4--none',
  Q_AND_A: true,
  REMOVED_SPECIFICATIONS: ['other'],
  REVIEWS: false,
  REVIEWS_WRITE_REVIEW_ENABLED: false,
  SHOP_COLLECTION: false,
  SHOW_ARGOSCARD_LOGO_FINANCE_ACCORDION: true,
  SOLD_BY_ARGOS: false,
  SPECIFICATION_TABLE: true,
  STICKY_BAR: true,
  TEMPLATE_TYPE: 'WHITE_GOODS',
  WISHLIST: true
}

export default WhiteGoodsOnArgosFeatures
